var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.checkedUserState)?[(!_vm.token || _vm.pages)?[(_vm.pages)?_c('router-view'):_vm._e()]:[_c('app-layout')]]:void 0],2)}
var staticRenderFns = []

export { render, staticRenderFns }